<template>
<div class="chapter">
<div class="inner_page">
<div class="cover" id="weitgmefm"><img alt="With Edwards in the Governor's Mansion eBook cover.jpg" class="cover" src="Images/WithEdwardsintheGo_fmt.jpeg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Cover.vue?df92d0ce